import React, { useEffect, useState } from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { HistoryRecordRow } from './HistoryRecordRow';
import './historyList.css';

export const EquipmentHistorySection = ({ title, events, testId, onAddLog, focusId, error, onRetry, ...actions }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [visible, setVisible] = useState(10);
  useEffect(() => {
    if (!focusId) return;
    const index = events.findIndex((e) => e.raw_id === focusId);
    if (index < 0) return;
    setCollapsed(false);
    setVisible((n) => Math.max(n, index + 1));
    setExpanded(events[index].id);
  }, [focusId, events]);
  useEffect(() => {
    if (focusId && expanded) document.getElementById(`history-record-${expanded}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [expanded, focusId]);
  return <section className="history-report equipment-history" data-testid={testId}>
    <div className="equipment-history-heading">
      <button type="button" onClick={() => setCollapsed((v) => !v)} aria-expanded={!collapsed}
        aria-controls={`${testId}-body`} data-testid={`${testId}-toggle`}>
        <ChevronDown size={16} className={collapsed ? '-rotate-90' : ''} />
        <h2>{title}</h2><span data-testid={`${testId}-count`}>{events.length}</span>
      </button>
      {onAddLog && <Button size="sm" variant="outline" onClick={onAddLog} data-testid="add-log-btn"><Plus size={14} className="mr-1" /> Add Log</Button>}
    </div>
    {!collapsed && <div id={`${testId}-body`} data-testid={`${testId}-body`}>
      {error ? <div className="history-list-state" role="alert" data-testid={`${testId}-error`}><p>{error}</p>
        <Button variant="outline" onClick={onRetry} data-testid={`${testId}-retry`}>Retry</Button></div>
        : !events.length ? <p className="history-list-state" data-testid={`${testId}-empty`}>No records yet.</p> : <>
          <div className="history-list-head history-row-grid" aria-hidden="true"><span>Date</span><span>Work performed / outcome</span><span>Labor (h)</span><span>Follow-up</span><span /></div>
          <ol className="history-records">
            {events.slice(0, visible).map((e) => <HistoryRecordRow key={e.id} event={e} hideEquipment
              expanded={expanded === e.id} onToggle={() => setExpanded((value) => value === e.id ? null : e.id)} {...actions} />)}
          </ol>
          {visible < events.length && <div className="history-list-footer"><span data-testid={`${testId}-visible-count`}>{visible} of {events.length} records</span>
            <Button size="sm" variant="outline" data-testid={`${testId}-more`} onClick={() => setVisible((n) => n + 10)}>Show more</Button></div>}
        </>}
    </div>}
  </section>;
};